import { render, staticRenderFns } from "./InvestProjects.vue?vue&type=template&id=450616d8&"
import script from "./InvestProjects.vue?vue&type=script&lang=ts&"
export * from "./InvestProjects.vue?vue&type=script&lang=ts&"
import style0 from "./InvestProjects.vue?vue&type=style&index=0&scopped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports